<template>
  <div id="app" class="row">
    <div class="left">
      <SideBar id="sidebar"/>
    </div>
    <div class="right">
      <router-view id="main" :photos="photos">
      </router-view>
    </div>
  </div>
</template>

<script>
// handling data from api should be done somewhere else
import SideBar from './components/SideBar.vue'
export default {
  data() {
    return {
      photos: {},
    }
  },
  //these would be nice to do in one function, but how?
  methods: {
    async fetchPhotos(){
      let response = await fetch('https://jsonplaceholder.typicode.com/photos');
      let data = await response.json()
      return data
    },

    async getPhotos() {
      this.photos = await this.fetchPhotos()
    },
  },
  components: {
    SideBar,
  },
  
  mounted() {
      this.getPhotos()
  },


}
</script>

<style>
body{
  margin: 0;
  padding: 0;
  background-color: #7e57c2;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
  width: 100%;
  height: 100%;
}
#sidebar {
  top: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  position: fixed;
  width: 10%;
}
.row {
  display: inline-flex;
}
.left {
  width: 20%;
}
.right {
  width: 80%;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  background-color: #7e57c2;
}

#main {
  top: 0;
  margin-left: 5px;
  bottom: 0;
  width: 100%;
}
</style>
